import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.every";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from "@/libs/util";
import { csmessageInitCs, csmessageInitPlayer, myConversations, csmessageMessage, csDisconnect, msgList, csUpload, csRead, unreadStatus, bindLeaveByCustomer, heartbeat } from "@/api/customerCenter/customerCenter";
import md5 from "js-md5";
import axios from 'axios';
export default {
  name: "customerCenter",
  mixins: [],
  data: function data() {
    return {
      activeMenu: 'processing',
      action: process.env.VUE_APP_API + "/cs-upload",
      headers: {
        'Authorization': '',
        'Request-Url': ''
      },
      searchData: {
        page: 1,
        page_size: 10
      },
      originalStatus: {
        "web": '官网',
        "game": "游戏"
      },
      total: 0,
      replyMsg: '',
      emojiVisible: false,
      emojiList: ["😀", "😁", "😂", "🤣", "😃", "😄", "😅", "😆", "😉", "😊", "😋", "😎", "😍", "😘", "😗", "😙", "😚", "☺️", "🙂", "🤗", "🤩", "🤔", "🤨", "😐", "😑", "😶", "🙄", "😏", "😣", "😥", "😮", "🤐", "😯", "😪", "😫", "😴", "😌", "😛", "😜", "😝", "🤤", "😒", "😓", "😔", "😕", "🙃", "🤑", "😲", "☹️", "🙁", "😖", "😞", "😟", "😤", "😢", "😭", "😦", "😧", "😨", "😩", "🤯", "😬", "😰", "😱", "😳", "🤪", "😵", "😡", "😠", "🤬", "👍", "👎", "👊", "✊", "🤛", "🤜", "🤞", "✌️", "🤟", "🤘", "👌", "👈", "👉", "👆", "👇", "✋", "🤚", "🖐", "🖖", "👋", "🤙", "💪", "🖕", "✍️", "🙏", "💍", "👑", "🎒"],
      ws: null,
      wsStatus: 'closed',
      wsUrl: 'ws://custom-msg-test.colocess.com/ws/customer',
      sessionList: [],
      selectedPlayerId: null,
      messageMap: {},
      currentCustomer: {
        customer_id: "",
        customer_name: "",
        role_name: ""
      },
      pendingRequests: {},
      chatLoadingMap: {},
      chatNoMoreMap: {},
      changeIndex: 0,
      search_name: '',
      // 💡 新增：WebSocket 稳定性控制变量
      reconnectTimer: null,
      // 重连定时器
      isReconnecting: false,
      // 防重连锁
      isNormalClosing: false,
      unreadStatusData: {},
      readPollingTimer: null,
      heartbeatTimer: null
    };
  },
  activated: function activated() {
    if (this.selectedPlayerId) {
      this.scrollToBottom();
    }
  },
  computed: {
    uploadHeaders: function uploadHeaders() {
      return {
        Authorization: util.cookies.get("token")
      };
    },
    currentSession: function currentSession() {
      var _this = this;

      if (!this.selectedPlayerId) return null;
      return this.sessionList.find(function (s) {
        return s.player_id === _this.selectedPlayerId;
      }) || null;
    },
    // 💡 新增：判断当前玩家是否处于断开（离线）状态
    isCurrentPlayerClosed: function isCurrentPlayerClosed() {
      return !this.currentSession || this.currentSession.status === 'closed';
    }
  },
  created: function created() {
    this.headers['Authorization'] = 'Bearer ' + (util.cookies.get('token') || '');
    this.headers['Request-Url'] = this.$route.path;
  },
  mounted: function mounted() {
    this.getMyConversations(1);
    this.initWebSocket();
    this.requestNotificationPermission();
    window.addEventListener('beforeunload', this.handleWindowClose);
    window.addEventListener('pagehide', this.handleWindowClose);
  },
  beforeDestroy: function beforeDestroy() {
    this.isNormalClosing = true; // 页面销毁时务必清除所有定时器，断开WS

    this.clearAllTimers();

    if (this.ws) {
      this.ws.close(1000, '页面关闭');
    }

    this.ws = null;
    window.removeEventListener('beforeunload', this.handleWindowClose);
    window.addEventListener('pagehide', this.handleWindowClose);

    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.readTimer) {
      clearTimeout(this.readTimer);
    }

    if (this.readPollingTimer) {
      clearInterval(this.readPollingTimer);
      this.readPollingTimer = null;
    }
  },
  methods: {
    requestNotificationPermission: function requestNotificationPermission() {
      if (!('Notification' in window)) {
        console.warn('当前浏览器不支持 Desktop Notifications API');
        return;
      }

      if (Notification.permission === 'default') {
        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            console.log('玩家消息通知权限已开启');
          }
        });
      }
    },
    // 💡 2. 触发系统桌面通知
    sendDesktopNotification: function sendDesktopNotification(msg) {
      // 判断浏览器支持情况及授权状态
      if (!('Notification' in window) || Notification.permission !== 'granted') {
        return;
      } // 提取解析发送者名称与推送文本


      var senderName = msg.player_name || '玩家';
      var displayContent = msg.content || ''; //let previewImage = '';

      if (msg.content_type === 'img') {
        displayContent = '[图片]'; //previewImage = msg.content;
      }

      ;
      if (msg.content_type === 'video') displayContent = '[视频]';
      var title = "\u65B0\u6D88\u606F\u901A\u77E5 - ".concat(senderName);
      var options = {
        body: displayContent,
        //icon: '/favicon.ico', // 可以替换为你项目的 LOGO 图片地址
        // image: previewImage,
        tag: "msg-".concat(msg.player_id),
        // 设置 tag 防止短时间内消息堆叠
        renotify: true,
        silent: false
      };

      try {
        var notification = new Notification(title, options); // 点击通知栏卡片：自动聚焦并切到该玩家页面

        notification.onclick = function () {
          // window.focus(); // 激活当前的浏览器 Tab 标签页
          // if (msg.player_id) {
          //   this.handleActivePlayer(msg.player_id);
          // }
          notification.close();
        };
      } catch (e) {
        console.error('弹窗通知失败:', e);
      }
    },
    getMyConversations: function getMyConversations(e) {
      var _this2 = this;

      if (e) this.searchData.page = e;
      this.searchData.type = this.activeMenu;
      this.searchData.player_name = this.search_name;
      myConversations(this.searchData).then(function (res) {
        if (res.code == 200) {
          _this2.sessionList = res.data.data;
          _this2.total = res.data.total;
        }
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getMyConversations(1);
    },
    handlePaste: function handlePaste(event) {
      //if (this.isCurrentPlayerClosed) return;
      // 获取剪贴板数据
      var items = (event.clipboardData || window.clipboardData).items;
      var hasFile = false;

      for (var i = 0; i < items.length; i++) {
        var item = items[i]; // 如果粘贴的是文件（图片或视频）

        if (item.kind === 'file') {
          hasFile = true;
          var file = item.getAsFile();
          if (!file) continue; // 核心：如果是文件，强行阻止默认行为！不让文件图标或诡异的字符掉进输入框

          event.preventDefault(); // 类型判断与前置校验

          if (file.type.indexOf('image') !== -1) {
            if (this.beforeImageUpload(file)) {
              this.$message.info('正在发送粘贴的图片...');
              this.uploadFileDirectly(file, 'img');
            }
          } else if (file.type.indexOf('video') !== -1) {
            if (this.beforeVideoUpload(file)) {
              this.$message.info('正在发送粘贴的视频...');
              this.uploadFileDirectly(file, 'video');
            }
          }
        }
      }
    },
    // 2. 保持不变：直接上传并静默发送
    uploadFileDirectly: function uploadFileDirectly(file, type) {
      var _this3 = this;

      console.log("file==", file);
      console.log("type==", type);
      var formData = new FormData();
      formData.append('pic', file); // 注意：将这里的 this.$axios 替换为你项目实际的请求工具（如 this.$http 或 request）

      axios.post(this.action, formData, {
        headers: _objectSpread(_objectSpread({}, this.headers), {}, {
          'Content-Type': 'multipart/form-data'
        })
      }).then(function (res) {
        var responseData = res.data || res;

        if (responseData.status == 200) {
          var relativePath = type === 'img' ? responseData.data.image : responseData.data.video;
          var fileUrl = process.env.VUE_APP_CHATAPI + relativePath; // 直接触发发送，完美绕过输入框

          _this3.sendMessage(fileUrl, type);
        } else {
          _this3.$message.error(responseData.msg || responseData.message || '文件上传失败');
        }
      }).catch(function (err) {
        _this3.$message.error('粘贴文件发送失败，请重试');

        console.error(err);
      });
    },
    // 🚀 初始化 WebSocket
    initWebSocket: function initWebSocket() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var token, targetWsUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.ws && _this4.ws.readyState === WebSocket.OPEN)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!_this4.isNormalClosing) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                token = util.cookies.get("token");
                targetWsUrl = "".concat(process.env.VUE_APP_WEBSOCKETURL, "ws/customer?authorization=").concat(token);
                _this4.wsStatus = 'connecting';
                console.log("正在尝试连接 WebSocket...", targetWsUrl);
                _this4.ws = new WebSocket(targetWsUrl);

                _this4.ws.onopen = function () {
                  _this4.wsStatus = 'online';
                  _this4.isReconnecting = false; // 1. 客服上线：开启每 3 秒一次的 heartbeat 轮询

                  _this4.startHeartbeatPolling();

                  bindLeaveByCustomer().then(function (res) {
                    if (res.code == 200) {
                      _this4.getMyConversations(1);

                      _this4.getUnreadStatus();
                    }
                  });
                  console.log('客服端 WebSocket 连接成功');
                };

                _this4.ws.onmessage = function (event) {
                  var rawData = String(event.data).trim();
                  var msg = JSON.parse(rawData);

                  _this4.handleWsMessage(msg);

                  console.log("rawData===", rawData);
                };

                _this4.ws.onclose = function (e) {
                  // 2. 客服下线/断开：立即清除心跳轮询
                  _this4.stopHeartbeatPolling();

                  if (e.code != 1000) {
                    _this4.reportDisconnect('close'); // 触发后端断开接口，类型为异常

                  }

                  _this4.wsStatus = 'closed';
                  _this4.ws = null;
                  console.log(" WebSocket \u5DF2\u65AD\u5F00 (Code: ".concat(e.code, ")\uFF0C\u51C6\u5907\u5C1D\u8BD5\u91CD\u8FDE..."));

                  if (_this4.isNormalClosing) {
                    console.log("检测到页面属于主动关闭/销毁状态，已彻底阻断重连定时器。");
                    return;
                  }

                  _this4.triggerReconnect();
                };

                _this4.ws.onerror = function (err) {
                  _this4.wsStatus = 'error';
                  console.error('WebSocket 报错:', err); // error 后紧接着会触发 onclose，所以这里不需要写重连逻辑
                };

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 新增：启动心跳轮询
    startHeartbeatPolling: function startHeartbeatPolling() {
      var _this5 = this;

      this.stopHeartbeatPolling();
      this.sendHeartbeatRequest();
      this.heartbeatTimer = setInterval(function () {
        _this5.sendHeartbeatRequest();
      }, 3000);
    },
    // 新增：停止心跳轮询
    stopHeartbeatPolling: function stopHeartbeatPolling() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
        console.log("[心跳轮询] 客服已下线，心跳轮询已断开");
      }
    },
    // 新增：发送心跳请求的具体方法
    sendHeartbeatRequest: function sendHeartbeatRequest() {
      heartbeat().then(function (res) {}).catch(function (err) {
        console.error("[心跳轮询] heartbeat 请求报错:", err);
      });
    },
    reportDisconnect: function reportDisconnect() {
      var _this6 = this;

      var disconnectType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'network_err';
      var msg = arguments.length > 1 ? arguments[1] : undefined;

      // 基础数据校验
      if (!this.currentCustomer.customer_id) {
        console.log("⚠️ 未获取到当前客服ID，取消断开上报");
        return;
      }

      console.log("this.selectedPlayerId==", this.selectedPlayerId);
      var key = "FG42tghF8874";
      var playId = this.selectedPlayerId ? this.selectedPlayerId.toString() : msg ? msg.player_id : '';
      var customer_id = this.currentCustomer.customer_id;
      var signStr = playId + customer_id + disconnectType + key; // 生成 MD5 签名（默认生成 32 位小写密文）

      var signature = md5(signStr);
      var payload = {
        player_id: playId,
        customer_id: this.currentCustomer.customer_id,
        disconnect_type: disconnectType,
        // 对应你后端的参数名
        sign: signature
      };
      csDisconnect(payload).then(function (res) {
        if (res.code == 200) {
          _this6.getMyConversations(1);
        }
      });
    },
    // 🔒 安全重连机制（防并发锁）
    triggerReconnect: function triggerReconnect() {
      var _this7 = this;

      if (this.isReconnecting) return; // 如果正在等重连，别加塞

      this.isReconnecting = true;
      if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
      this.reconnectTimer = setTimeout(function () {
        console.log("正在执行第 N 次自动重连...");
        _this7.isReconnecting = false; // 释放锁

        _this7.initWebSocket();
      }, 5000); // 每 5 秒尝试重连一次
    },
    clearAllTimers: function clearAllTimers() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },
    // ✉️ 处理接收到的业务消息
    handleWsMessage: function handleWsMessage(msg) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var nowTime, isCurrentPlayer, session, _session;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("收到有效业务 WS 消息==", msg);
                nowTime = new Date(msg.timestamp || Date.now()).toLocaleString();
                _context2.t0 = msg.message_type;
                _context2.next = _context2.t0 === "connected" ? 5 : _context2.t0 === "init_msg" ? 8 : _context2.t0 === "send_msg" ? 12 : _context2.t0 === "disconnect" ? 25 : _context2.t0 === "ack" ? 29 : _context2.t0 === "account_preempted" ? 31 : _context2.t0 === "error" ? 36 : 38;
                break;

              case 5:
                console.log("\u5F53\u524D\u7CFB\u7EDF\u9A8C\u8BC1\u5BA2\u670D:", msg);
                _this8.currentCustomer = {
                  customer_id: msg.customer_id,
                  customer_name: msg.customer_name,
                  role_name: msg.role_name
                }; //this.handleInitCs(msg, 'waitting');

                return _context2.abrupt("break", 38);

              case 8:
                console.log("收到玩家匹配初始化通知:", msg);

                _this8.handleInitCs(msg, 'chatting');

                setTimeout(function () {
                  _this8.getMyConversations(1);
                }, 1000);
                return _context2.abrupt("break", 38);

              case 12:
                console.log("收到玩家的消息msg==", msg);

                if (!msg.player_id) {
                  _context2.next = 24;
                  break;
                }

                if (!_this8.messageMap[msg.player_id]) {
                  _this8.$set(_this8.messageMap, msg.player_id, []);
                }

                isCurrentPlayer = msg.player_id === _this8.selectedPlayerId;

                _this8.messageMap[msg.player_id].push({
                  isSelf: false,
                  content: msg.content,
                  content_type: msg.content_type || 'text',
                  // 💡 接收后端的类型
                  // read: isCurrentPlayer ? 1 : 0,
                  time: nowTime
                });

                session = _this8.sessionList.find(function (s) {
                  return s.player_id === msg.player_id;
                });

                if (session) {
                  session.last_msg = msg.content; // 💡 动态为 session 对象注入类型，确保列表响应式渲染

                  _this8.$set(session, 'last_msg_type', msg.content_type || 'text');
                }

                if (document.hidden || !isCurrentPlayer) {
                  _this8.sendDesktopNotification(msg);
                }

                _context2.next = 22;
                return _this8.savePlayerMsg(msg, isCurrentPlayer);

              case 22:
                setTimeout(function () {
                  _this8.getMyConversations(1);

                  _this8.getUnreadStatus();
                }, 500);

                _this8.scrollToBottom();

              case 24:
                return _context2.abrupt("break", 38);

              case 25:
                console.log("我之心换个", msg);

                _this8.reportDisconnect('disconnect', msg);

                if (msg.player_id) {
                  _this8.$message.warning("\u73A9\u5BB6 [".concat(msg.player_id, "] \u5DF2\u79BB\u7EBF"));

                  _session = _this8.sessionList.find(function (s) {
                    return s.player_id === msg.player_id;
                  });
                  if (_session) _session.status = 'closed';
                }

                return _context2.abrupt("break", 38);

              case 29:
                if (_this8.pendingRequests[msg.request_id]) {
                  _this8.pendingRequests[msg.request_id].status = 'success';
                  delete _this8.pendingRequests[msg.request_id];
                }

                return _context2.abrupt("break", 38);

              case 31:
                console.error(" 账号在其他地方登录，当前连接已被踢出:", msg);
                if (_this8.reconnectTimer) clearTimeout(_this8.reconnectTimer); // 1. 给出明确提示

                _this8.$alert('您的账号已在其他设备登录，当前连接已断开。', '下线通知', {
                  confirmButtonText: '确定',
                  type: 'warning',
                  callback: function callback(action) {}
                });

                if (_this8.ws) {
                  _this8.ws.onclose = null; // 关键：防止触发原本绑定的自动重连

                  _this8.ws.onerror = null; //关键：防止报错引发重连

                  _this8.ws.onmessage = null; // 手动关闭，Code 1000 表示正常关闭

                  _this8.ws.close(1000, "account_preempted");

                  _this8.ws = null;
                }

                return _context2.abrupt("break", 38);

              case 36:
                if (_this8.pendingRequests[msg.request_id]) {
                  // this.pendingRequests[msg.request_id].status = 'error';
                  delete _this8.pendingRequests[msg.request_id];
                } // this.$message.error(`消息发送失败: ${msg.message}`);


                return _context2.abrupt("break", 38);

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    savePlayerMsg: function savePlayerMsg(msg, isCurrentPlayer) {
      console.log("收到玩家的新消息了");
      var playerData = msg.player_id.split(':') || [];
      var key = "FG42tghF8874";
      var senderId = playerData[3].toString();
      var senderName = msg.player_name; // 拼接：sender_id + sender_name + content + key

      var signStr = senderId + senderName + msg.content + key;
      var signature = md5(signStr);
      var payload = {
        // 基本消息三要素
        conversation_id: this.conversation_id || 0,
        // 无有效会话时传入0或旧会话，靠后端内部去重或兜底创建
        sender_type: "player",
        sender_id: playerData[3],
        sender_name: msg.player_name,
        message_type: "send_msg",
        content_type: msg.content_type,
        content: msg.content,
        hasSelect: isCurrentPlayer,
        // 后端强校验的兜底/创建会话全量参数
        customer_id: this.currentCustomer.customer_id,
        customer_name: this.currentCustomer.customer_name,
        customer_role_name: this.currentCustomer.role_name,
        game: playerData[0],
        player_id: msg.player_id,
        game_name: msg.game_name,
        server_id: playerData[2],
        server_name: msg.server_name,
        user_id: playerData[1],
        role_id: playerData[3],
        // server_name: this.playerInfo.server_name,
        player_name: msg.player_name,
        // recharge_amount: this.playerInfo.recharge_amount,
        // role_name: this.playerInfo.role_name,
        sign: signature
      };
      console.log("jaosijof");
      csmessageMessage(payload).then(function (res) {
        console.log("消息保存成功");
      });
    },
    getUnreadStatus: function getUnreadStatus() {
      var _this9 = this;

      unreadStatus().then(function (res) {
        if (res.code == 200) {
          _this9.unreadStatusData = res.data;
        }
      });
    },
    handleInitCs: function handleInitCs(msg, status) {
      var playData = msg.player_id ? msg.player_id.split(':') : [];
      csmessageInitCs({
        customer_id: this.currentCustomer.customer_id,
        customer_name: this.currentCustomer.customer_name,
        customer_role_name: this.currentCustomer.role_name,
        status: status,
        player_id: msg.player_id,
        player_name: msg.player_name,
        disconnect_type: msg.disconnect_type,
        game: msg.game,
        game_name: msg.game_name,
        server_id: playData[2],
        server_name: msg.server_name,
        user_id: playData[1],
        role_id: playData[3],
        recharge_amount: msg.recharge_amount
      }).then(function (res) {
        if (res.code == 200) {
          console.log("\u4F1A\u8BDD\u72B6\u6001\u66F4\u65B0\u6210\u529F [".concat(status, "]"));
        }
      }).catch(function (err) {
        console.error("更新会话接口报错：", err);
      });
    },
    handleActivePlayer: function handleActivePlayer(playerId) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var clickedSession, currentMessages, hasUnreadCustomerMsg;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this10.stopReadPolling();

                _this10.selectedPlayerId = playerId;

                if (!_this10.messageMap[playerId]) {
                  _this10.$set(_this10.messageMap, playerId, []);
                }

                clickedSession = _this10.sessionList.find(function (item) {
                  return item.player_id === playerId;
                });

                if (clickedSession) {
                  clickedSession.unread_count = 0;
                } // 初次切换过来，拉取最新的一页历史（即不传 before，让后端默认返回最新几条）


                _context3.next = 7;
                return _this10.fetchHistoryMessages(playerId, 'init');

              case 7:
                currentMessages = _this10.messageMap[playerId] || [];
                hasUnreadCustomerMsg = currentMessages.some(function (msg) {
                  return msg.isSelf && Number(msg.read) === 0;
                });

                if (hasUnreadCustomerMsg) {
                  console.log("[\u5165\u53E3\u6FC0\u6D3B] \u68C0\u6D4B\u5230\u5F53\u524D\u9009\u4E2D\u7684\u73A9\u5BB6 [".concat(playerId, "] \u5386\u53F2\u8BB0\u5F55\u4E2D\u5B58\u5728\u672A\u8BFB\u5BA2\u670D\u6D88\u606F\uFF0C\u7ACB\u5373\u6FC0\u6D3B 5 \u79D2\u8F6E\u8BE2\u76D1\u7763..."));

                  _this10.startReadPolling(); // 发现有未读，立刻启动轮询

                }

                setTimeout(function () {
                  _this10.getUnreadStatus();
                }, 500);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    fetchHistoryMessages: function fetchHistoryMessages(playerId) {
      var _arguments = arguments,
          _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var mode, currentSession, params, res, rawList, formattedMsgs, msgBox;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mode = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 'init';

                if (!_this11.chatLoadingMap[playerId]) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                // 找到当前选中的会话对象，提取 conversation_id
                currentSession = _this11.sessionList.find(function (s) {
                  return s.player_id === playerId;
                });

                if (!(!currentSession || !currentSession.id)) {
                  _context4.next = 8;
                  break;
                }

                console.error("未能找到该会话的 conversation_id");

                _this11.$set(_this11.chatLoadingMap, playerId, false);

                return _context4.abrupt("return");

              case 8:
                // 组装后端需要的 Query 参数
                params = {
                  conversation_id: currentSession.id
                };
                _context4.prev = 9;
                _context4.next = 12;
                return msgList(params);

              case 12:
                res = _context4.sent;

                if (res.code == 0) {
                  rawList = res.data || []; // 字段映射转换

                  formattedMsgs = rawList.map(function (item) {
                    return {
                      id: item.id,
                      isSelf: item.sender_type === 'customer',
                      read: item.read,
                      content: item.content,
                      content_type: item.content_type,
                      time: item.timestamp ? new Date(item.timestamp).toLocaleString() : item.create_time,
                      status: 'success',
                      rawTimestamp: item.timestamp // 极其重要：保存原始秒级/毫秒级时间戳，留作下次翻页的 before 参数

                    };
                  }); // 注意：基于 before 获取的历史记录，后端返回的顺序如果是按时间倒序(最新在前面)
                  // 渲染在聊天面板时需要逆序排列展示(最早在最前)
                  // 如果你后端返回的数组已经是[时间远 -> 时间近]递增，则不需要加下面这一行 .reverse()

                  formattedMsgs.reverse();
                  msgBox = _this11.$refs.messageBox;

                  _this11.$set(_this11.messageMap, playerId, formattedMsgs);

                  _this11.$nextTick(function () {
                    _this11.scrollToBottom();
                  });
                } else {
                  _this11.$message.error(res.message || '获取消息列表失败');
                }

                _context4.next = 19;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](9);
                console.error("请求消息列表异常:", _context4.t0);

              case 19:
                _context4.prev = 19;
                return _context4.finish(19);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[9, 16, 19, 21]]);
      }))();
    },
    // 3. 监听聊天框滚动事件
    handleScroll: function handleScroll(event) {
      var target = event.target; // 💡 当 scrollTop 等于 0 时，说明用户已经将滚动条一页滑到了最顶部

      if (target.scrollTop === 0 && this.selectedPlayerId) {
        console.log("触顶了，开始加载更早的历史记录...");
        this.fetchHistoryMessages(this.selectedPlayerId, 'append');
      }
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }

      return isLt2M;
    },
    beforeVideoUpload: function beforeVideoUpload(file) {
      var isLt50M = file.size / 1024 / 1024 < 50;

      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 50MB!');
      }

      return isLt50M;
    },
    upSuccess: function upSuccess(response) {
      console.log("response===", response);

      if (response.status == 200) {
        var relativePath = response.data.image; //const fileUrl = process.env.VUE_APP_CHATAPI + '/storage/' + relativePath;

        var fileUrl = process.env.VUE_APP_CHATAPI + relativePath;
        console.log("fileUrl", fileUrl);
        this.sendMessage(fileUrl, 'img');
      } else {
        this.$message.error(response.msg || response.message);
      }
    },
    upVideoSuccess: function upVideoSuccess(response) {
      console.log("response===", response);

      if (response.status == 200) {
        var relativePath = response.data.video; //const fileUrl = process.env.VUE_APP_CHATAPI + '/storage/' + relativePath;

        var fileUrl = process.env.VUE_APP_CHATAPI + relativePath;
        console.log("fileUrl", fileUrl);
        this.sendMessage(fileUrl, 'video');
      } else {
        this.$message.error(response.msg || response.message);
      }
    },
    sendMessage: function sendMessage() {
      var _arguments2 = arguments,
          _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var mediaUrl, mediaType, isMedia, currentMsgText, contentType, currentSession, playData, requestId, nowTime, localMsgObj, key, senderId, senderName, signStr, signature, payload;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                mediaUrl = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : '';
                mediaType = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : 'text';

                if (!(!_this12.ws || _this12.ws.readyState !== WebSocket.OPEN)) {
                  _context5.next = 5;
                  break;
                }

                _this12.$message.error('WebSocket 未连接，请等待重连成功后再试');

                return _context5.abrupt("return");

              case 5:
                if (_this12.selectedPlayerId) {
                  _context5.next = 8;
                  break;
                }

                _this12.$message.error('请先在左侧选择一个玩家');

                return _context5.abrupt("return");

              case 8:
                //if (!this.replyMsg.trim()) return;
                console.log("mediaUrl==", mediaUrl);
                isMedia = mediaUrl != '';
                console.log("isMedia==", isMedia);
                currentMsgText = isMedia ? mediaUrl : _this12.replyMsg.trim();
                contentType = isMedia ? mediaType : 'text';

                if (!(!isMedia && !currentMsgText.trim())) {
                  _context5.next = 15;
                  break;
                }

                return _context5.abrupt("return");

              case 15:
                // 2. 找到当前选中的玩家会话对象，用于提取兜底创建会话所需的字段
                currentSession = _this12.sessionList.find(function (s) {
                  return s.player_id === _this12.selectedPlayerId;
                });

                if (currentSession) {
                  _context5.next = 19;
                  break;
                }

                _this12.$message.error('未找到该玩家的本地会话数据');

                return _context5.abrupt("return");

              case 19:
                // 解析 player_id (格式通常为 "game:user_id:server_id:role_id")
                playData = _this12.selectedPlayerId ? _this12.selectedPlayerId.split(':') : []; //const currentMsgText = this.replyMsg; 

                requestId = "cust-req-".concat(Date.now());
                nowTime = new Date().toLocaleString(); // 3. 构建本地 UI 渲染所需的对象

                localMsgObj = {
                  isSelf: true,
                  content: currentMsgText,
                  // contentType: contentType, // 💡 保存消息内容类型
                  content_type: contentType,
                  // 💡 双向兼容字段
                  time: nowTime,
                  status: 'sending',
                  read: 0 //玩家离线默认未读

                }; // 初始化并推入本地聊天记录映射表

                if (!_this12.messageMap[_this12.selectedPlayerId]) {
                  _this12.$set(_this12.messageMap, _this12.selectedPlayerId, []);
                }

                _this12.messageMap[_this12.selectedPlayerId].push(localMsgObj);

                _this12.pendingRequests[requestId] = localMsgObj;
                currentSession.last_msg = currentMsgText;

                _this12.$set(currentSession, 'last_msg_type', contentType);

                key = "FG42tghF8874";
                senderId = _this12.currentCustomer.customer_id.toString();
                senderName = _this12.currentCustomer.customer_name; // 拼接：sender_id + sender_name + content + key

                signStr = senderId + senderName + currentMsgText + key; // 生成 MD5 签名（默认生成 32 位小写密文）

                signature = md5(signStr); // 4. 构建符合后端完全体要求的 Payload 参数

                payload = {
                  // 基础消息字段
                  conversation_id: currentSession.id || 0,
                  // 如果后端列表带了id就传，没有就传0或按后端习惯
                  sender_type: "customer",
                  sender_id: _this12.currentCustomer.customer_id.toString(),
                  sender_name: _this12.currentCustomer.customer_name,
                  message_type: "send_msg",
                  content_type: contentType,
                  content: currentMsgText,
                  request_id: requestId,
                  // 对应你在 ack 里的判断
                  customer_id: _this12.currentCustomer.customer_id,
                  customer_name: _this12.currentCustomer.customer_name,
                  customer_role_name: _this12.currentCustomer.role_name,
                  role_name: _this12.currentCustomer.role_name,
                  // 接口参数里有重复的 role_name 要求
                  hasSelect: true,
                  player_id: _this12.selectedPlayerId,
                  player_name: currentSession.player_name || '',
                  game: currentSession.game || playData[0] || '',
                  game_name: currentSession.game_name || '',
                  server_id: currentSession.server_id || playData[2] || '',
                  server_name: currentSession.server_name || '',
                  user_id: currentSession.user_id || playData[1] || '',
                  role_id: currentSession.role_id || playData[3] || '',
                  recharge_amount: currentSession.recharge_amount || 0,
                  sign: signature // timestamp: Date.now()

                };

                if (currentSession.status === 'closed') {
                  payload.leave = true;
                }

                try {
                  // 同时通过 HTTP 接口向后端同步该条消息（依照你们项目同时引入了 csmessageMessage 来看）
                  csmessageMessage(payload).then(function (res) {
                    if (res.code === 200) {
                      localMsgObj.status = 'success';
                      var wsPayload = {
                        message_type: "send_msg",
                        request_id: requestId,
                        timestamp: Date.now(),
                        player_id: _this12.selectedPlayerId,
                        content_type: contentType,
                        content: currentMsgText
                      }; // 甩出数据帧，客服端听到这声信令，界面就会实时弹出消息了！

                      _this12.ws.send(JSON.stringify(wsPayload));

                      _this12.startReadPolling();
                    } else {
                      localMsgObj.status = 'error';

                      _this12.$message.error(res.message || '消息同步失败');
                    }
                  }).catch(function (err) {
                    localMsgObj.status = 'error';
                    console.error('HTTP 同步客服消息报错:', err);
                  });
                } catch (error) {
                  localMsgObj.status = 'error';
                  console.error('WebSocket 发送失败:', error);
                } // 6. 清空输入框并滚动到底部


                _this12.replyMsg = '';

                _this12.scrollToBottom();

              case 38:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    startReadPolling: function startReadPolling() {
      var _this13 = this;

      // 如果当前已经有轮询在跑了，先关掉它重新计时，保证单一定时器实例
      if (this.readPollingTimer) {
        clearInterval(this.readPollingTimer);
      }

      console.log("[轮询控制] 已读状态监测轮询已启动...");

      var doCheck = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
          var currentSession, targetPlayerId, res, rawList, isAllRead, formattedMsgs;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (_this13.selectedPlayerId) {
                    _context6.next = 3;
                    break;
                  }

                  _this13.stopReadPolling();

                  return _context6.abrupt("return");

                case 3:
                  currentSession = _this13.sessionList.find(function (s) {
                    return s.player_id === _this13.selectedPlayerId;
                  });

                  if (!(!currentSession || !currentSession.id)) {
                    _context6.next = 7;
                    break;
                  }

                  _this13.stopReadPolling();

                  return _context6.abrupt("return");

                case 7:
                  // 保存当前请求触发时的 playerId，用于应对异步延时网络请求返回时的比对
                  targetPlayerId = _this13.selectedPlayerId;
                  _context6.prev = 8;
                  _context6.next = 11;
                  return msgList({
                    conversation_id: currentSession.id
                  });

                case 11:
                  res = _context6.sent;

                  if (!(res.code == 0)) {
                    _context6.next = 17;
                    break;
                  }

                  rawList = res.data || []; // 严谨校验：如果请求响应回来时，客服已经切换到其他玩家了，这次的数据就不处理

                  if (!(_this13.selectedPlayerId !== targetPlayerId)) {
                    _context6.next = 16;
                    break;
                  }

                  return _context6.abrupt("return");

                case 16:
                  if (rawList.length > 0) {
                    //  核心判定：检查接口返回的列表里，是不是【每一个】item 的 read 都等于 1
                    isAllRead = rawList.every(function (item) {
                      return Number(item.read) === 1;
                    });

                    if (isAllRead) {
                      console.log("[轮询控制] 玩家已阅读所有消息，正在主动停止轮询。");

                      _this13.stopReadPolling(); // 满足需求：全部已读，停止轮询

                    } // 顺便动态更新当前的 UI 视图，让红点“● 未读”立刻变成灰色的“已读”


                    formattedMsgs = rawList.map(function (item) {
                      return {
                        id: item.id,
                        isSelf: item.sender_type === 'customer',
                        read: item.read,
                        content: item.content,
                        content_type: item.content_type,
                        time: item.timestamp ? new Date(item.timestamp).toLocaleString() : item.create_time,
                        status: 'success'
                      };
                    });
                    formattedMsgs.reverse();

                    _this13.$set(_this13.messageMap, targetPlayerId, formattedMsgs);
                  }

                case 17:
                  _context6.next = 22;
                  break;

                case 19:
                  _context6.prev = 19;
                  _context6.t0 = _context6["catch"](8);
                  console.error("[轮询控制] 请求已读状态异常:", _context6.t0);

                case 22:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, null, [[8, 19]]);
        }));

        return function doCheck() {
          return _ref.apply(this, arguments);
        };
      }();

      doCheck(); // 4. 步入正轨：每 5 秒自动循环请求

      this.readPollingTimer = setInterval(doCheck, 5000);
    },
    // 💡 新增方法 2：停止轮询并清空句柄
    stopReadPolling: function stopReadPolling() {
      if (this.readPollingTimer) {
        clearInterval(this.readPollingTimer);
        this.readPollingTimer = null;
        console.log("[轮询控制] 轮询已安全关闭。");
      }
    },
    handleMenuSelect: function handleMenuSelect(index) {
      this.activeMenu = index;
      this.selectedPlayerId = null;
      this.replyMsg = '';
      this.searchData.page = 1;
      this.getMyConversations(1);
    },
    handleSelectEmoji: function handleSelectEmoji(emoji) {
      var textarea = this.$refs.replyInput.$refs.textarea;

      if (!textarea) {
        this.replyMsg += emoji;
        return;
      }

      var startPos = textarea.selectionStart;
      var endPos = textarea.selectionEnd;
      var scrollTop = textarea.scrollTop;
      this.replyMsg = this.replyMsg.substring(0, startPos) + emoji + this.replyMsg.substring(endPos, this.replyMsg.length);
      this.emojiVisible = false;
      this.$nextTick(function () {
        textarea.focus();
        var newCursorPos = startPos + emoji.length;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
        textarea.scrollTop = scrollTop;
      });
    },
    scrollToBottom: function scrollToBottom() {
      var _this14 = this;

      this.$nextTick(function () {
        var box = _this14.$refs.messageBox;

        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      });
    },
    handleWindowClose: function handleWindowClose(event) {
      this.isNormalClosing = true;
    }
  }
};